import axios from "axios";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import * as helper from "../../../helpers";
axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').content;
const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;



export const ERROR_MESSAGE = {
  error: "There was an error processing your request. Please try again later",
};

export async function getSpecialistReferrals() {
  return await (
    await axios.get("patient_portal/api/specialist_referrals")
  ).data;
};

export async function locateAddress(req) {
  try {
    let res = await axios.get(
      queryString.stringifyUrl({
        url: "https://maps.googleapis.com/maps/api/geocode/json?",
        query: {
          ...req,
        },
      })
    );
    return res.data.results[0].geometry.location;
  } catch (error) {
    console.log("API[locateAddress])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
}

export async function getPcps() {
  try {
    return await (
      await axios.get("patient_portal/pcps")
    ).data;
  } catch (error) {
    console.log("API[getPatientData])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
}

export const markCprAsRead = async (cpr_id) => {
  try {
    return await (
      await axios.put("patient_portal/cprs", {
        action_type: 'mark_as_read',
        cpr: { id: cpr_id }
      })
    ).data;
  } catch (error) {
    console.log("API[markCprAsRead])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
}

export const getPatientData = async () => {
  try {

    // we need to read the URL to send to patient_data endpoint.
    // this allows us to know when the patient accessed this page from which notification and what type of notification.
    let queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let notificationId = urlParams.get('notification_id');
    let notificationType = urlParams.get('notification_type');

    return await (
      await axios.get("patient_portal/patient_data", {params: {
        'notification_id': notificationId,
        'notification_type': notificationType
      }})
    ).data;
  } catch (error) {
    console.log("API[getPatientData])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const getSupportMessages = async () => {
  try {
    return await (
      await axios.get("task_messages")
    ).data;
  } catch (error) {
    console.log("API[getSupportMessages])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const getCprById = async (id) => {
  try {
    return await (
      await axios.get("cprs/" + `${id}`)
    ).data;
  } catch (error) {
    console.log("API[getCprById])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const getCprsWithNotifications = async () => {
  try {
    return await (
      await axios.get("patient_portal/cprs?&attention=true")
    ).data;
  } catch (error) {
    console.log("API[getCprsWithNotifications])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const getClosedCprs = async (page) => {
  try {
    return await (
      await axios.get("patient_portal/cprs?&status=closed&page=" + `${page}`)
    ).data;
  } catch (error) {
    console.log("API[getClosedCprs])", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};
export const getAllCprsInProgress = async (page) => {
  try {
    return await (
      await axios.get("patient_portal/cprs?&page=" + `${page}`)
    ).data;
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return error;
  }
};
export const getMessages = async (page) => {
  try {
    return await (
      await axios.get("patient_portal/messages/list?&page=" + `${page}`)
    ).data;
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return error;
  }
};

export const getMessagebyId = async (id) => {
  try {
    return await (
      await axios.get("patient_portal/messages/" + `${id}`)
    ).data;
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return error;
  }
};

export const postCprStatus = async (req) => {
  try {
    return await axios.post("responses.json", req, {
      headers: {
        'X-CSRF-Token': csrfToken(),
        accept: "application/json",
      },
    });
  } catch (error) {
    console.log("API[postCprStatus)", error);
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const postCprStatusFormData = async (req) => {
  try {
    return await axios.post("responses.json", req, {
      headers: { "Content-Type": "multipart/form-data", processData: "false" },
    });
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const postTaskMessage = async (req) => {
  try {
    if (req.constructor.name == "FormData") {
      return await helper.postToResource("task_messages", req);
    } else {
      return await axios.post("task_messages", req, {
        headers: {
          'X-CSRF-Token': csrfToken(),
          accept: "application/json",
        },
      });
    }
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const getTaskMessages = async (cpr_id, page) => {
  try {
    let url = `task_messages?page=${ page }`;

    if (cpr_id) {
      url = url + `&cpr_id=${ cpr_id }`
    }

    return await axios.get(url);
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const postCustomResponse = async (req) => {
  try {
    return await axios.post("custom_responses", req, {
      headers: {
        'X-CSRF-Token': csrfToken(),
        accept: "application/json",
      },
    });
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const updateToCpr = async (req) => {
  try {
    return await axios.put("cprs/" + `${req.id}`, req, {
      headers: {
        'X-CSRF-Token': csrfToken(),
        accept: "application/json",
      },
    });
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};

export const postToPatientSettings = async (req) => {
  try {
    return await axios.post("patient_portal/save_settings", req, {
      headers: {
        'X-CSRF-Token': csrfToken(),
        accept: "application/json",
      },
    });
  } catch (error) {
    if(window.NREUM) {
      window.NREUM.noticeError(error);
    }
    return { ...ERROR_MESSAGE };
  }
};
